/* global $:false, data:false */

var generic = generic || {};
var site = site || {};

site.offerspick = site.offerspick || {};
site.template = site.template || {};
site.onLoadRpc = site.onLoadRpc || {};

site.offerspick = {
  offercode: '',
  template: 'offers_pick_item_v2',
  products: '',
  productData: [],
  selectedSku: 0,
  eventCount: 0,
  transData: {
    offers: '',
    samples: ''
  },
  init: function () {
    console.log('-- init --');
    this.getData();
  },
  getData: function () {
    var self = this;

    self.offercode = $('.js-samplespick').data('offercode');
    console.log('offercode: ' + self.offercode);
    // choicesPcatData ?
    // 'method': 'offers.query'
    site.onLoadRpc.requests.push({
      'method': 'offer',
      'params': [self.offercode],
      onSuccess: function (data) {
        var offer = data.result.value;
        var isActive = offer && (offer.timing === 'active');

        // show if active
        if (isActive) {
          self.products = offer.benefits[0].choices;
          $(document).trigger('offerData:loaded');
        }
      },
      onFailure: function (data) {}
    });
    // trans info
    site.onLoadRpc.requests.push({
      'method': 'trans.get',
      'params': [
        {
          'trans_fields': ['TRANS_ID', 'totals'],
          'payment_fields': [],
          'order_fields': ['items', 'samples', 'offerCodes']
        }
      ],
      onSuccess: function (data) {
        console.log('trans.get -- check samples');
        console.log(data);
        try {
          self.transData.offers = data.result.value.offerCodes;
          self.transData.samples = data.result.value.order.samples;
        } catch (e) {}
        $(document).trigger('transData:loaded');
      },
      onFailure: function (data) {}
    });
  },
  getProducts: function () {
    var self = this;
    var params = {
      'query_key': 'catalog-mpp',
      'products': self.products
    };

    console.log('-- get prods --');
    console.log(params);

    generic.jsonrpc.fetch({
      method: 'prodcat.querykey',
      params: [params],
      onSuccess: function (response) {
        console.log('-- catalog-mpp --');
        console.log(response.getValue());
        self.productData = response.getValue().products;
        // console.log(self.productData);
        self.renderProducts();
      },
      onFailure: function (response) {}
    });
  },
  renderProducts: function () {
    var self = this;

    $.each(self.productData, function (index, data) {
      data['sku_base_id'] = data.skus[0].SKU_BASE_ID;
      // check inventory
      var inventory = data.skus[0].INVENTORY_STATUS;

      // check inventory
      data.stock = inventory == 2 || inventory == 3 || inventory == 5 || inventory == 7 ? 0 : 1;
      var $offer = site.template.get({
        name: self.template,
        data: data
      });

      $('.samplespick__offers', '.samplespick').append($offer);
    });
    $('.samplespick__loader', '.samplespick').addClass('hidden');
    self.checkCart();
  },
  checkCart: function () {
    var self = this;

    // is item alredy in cart?
    $.each(self.transData.offers, function (index, offer) {
      if (offer === self.offercode) {
        $.each(self.transData.samples, function (index, sample) {
          // sample.sku.SKU_BASE_ID
          // console.log(sample['sku.SKU_BASE_ID']);
          var cartSku = sample['sku.SKU_BASE_ID'];
          var $selected = $('.js-add-offer[data-sku-base-id="' + cartSku + '"]', '.samplespick');

          if ($selected.length) {
            self.selectedSku = sample['sku.SKU_BASE_ID'];
          }
        });
      }
    });

    self.cartActions();
  },
  cartActions: function () {
    var self = this;
    // add to cart
    var $addBtns = $('.js-add-offer', '.samplespick');

    $addBtns.click(function (event) {
      console.log('add click');
      var skuBaseId = $(this).data('sku-base-id');

      self.addOfferCart(skuBaseId);
    });
    // remove from cart
    var $removeBtns = $('.js-remove-offer', '.samplespick');

    $removeBtns.click(function (event) {
      var skuBaseId = $(this).data('sku-base-id');

      self.removeOfferCart(skuBaseId);
    });

    // already in cart
    if (self.selectedSku) {
      console.log('-- already in cart --');
      self.offerSelected();
    }
  },
  addOfferCart: function (skuBaseId) {
    var self = this;

    self.selectedSku = skuBaseId;
    var skuBaseId = skuBaseId.toString();
    var $loader = $('.js-samplespick__button__loader[data-sku-base-id="' + self.selectedSku + '"]', '.samplespick');

    $loader.removeClass('hidden');
    // offer.apply
    var params = {
      'offer_code': self.offercode,
      'benefits': {
        'ChoiceOfSkus': {
          'choices': [skuBaseId]
        }
      }
    };

    generic.jsonrpc.fetch({
      method: 'offers.apply',
      params: [params],
      onSuccess: function (response) {
        console.log('added to cart rpc success');
        console.log(response.getValue());
        console.log(response.getMessages());
        self.offerSelected();
        self.cartConfirm();
        $loader.addClass('hidden');
      },
      onFailure: function (response) {
        // display error
        console.log('error adding to cart');
      }
    });
  },
  removeOfferCart: function () {
    // offer.removeOfferByCode
    var self = this;
    var params = {
      'offer_code': self.offercode
    };
    var $loader = $('.js-samplespick__button__loader[data-sku-base-id="' + self.selectedSku + '"]', '.samplespick');

    $loader.removeClass('hidden');

    generic.jsonrpc.fetch({
      method: 'offer.removeOfferByCode',
      params: [params],
      onSuccess: function (response) {
        // console.log('removed');
        // console.log(response.getValue());
        // console.log(response.getMessages());
        self.offerRemoved();
        $loader.addClass('hidden');
      },
      onFailure: function (response) {
        // display error
        console.log('error adding to cart');
      }
    });
  },
  offerSelected: function () {
    var self = this;

    console.log('-- offer selected --');
    // $('.js-remedies-product','.samplespick').addClass('hidden');
    var $selected = $('.js-add-offer[data-sku-base-id="' + self.selectedSku + '"]', '.samplespick').closest('.js-remedies-product');

    $('.js-remedies-product', '.samplespick').not($selected).addClass('hidden');
    $selected.removeClass('hidden').addClass('is_selected');
    // var $container = $('.samplespick').closest('.product_collection_hero__content-item');
    $('.samplespick').addClass('samplespick--selected');
    // if($container.length){
    $('html, body').animate({
      // scrollTop: $container.offset().top - 100
      scrollTop: 0
    }, 100);
    // }
  },
  offerRemoved: function () {
    $('.js-remedies-product', '.samplespick').removeClass('hidden is_selected');
    $('.samplespick').removeClass('samplespick--selected');
  },
  cartConfirm: function () {
    // copied from cart_confirm.js
    // js/shared/cart_confirm.js
    generic.jsonrpc.fetch({
      'method': 'trans.get',
      'params': [
        {
          'trans_fields': ['TRANS_ID', 'totals'],
          'payment_fields': [],
          'order_fields': ['items', 'samples', 'offerCodes']
        }
      ],
      'onSuccess': function (d) {
        var cartResponse = d.getValue();

        console.log('-- cartResponse --');
        console.log(cartResponse);
        if ((typeof cartResponse === 'undefined') || !cartResponse) {
          return;
        }
        var args = {
          trans: cartResponse,
          items: cartResponse.order.items
        };

        site.cartConfirm.launch(args);
      },
      onError: function () {}
    });
  }
};

$(document).on('offerData:loaded transData:loaded', function (event) {
  if (event.type === 'offerData:loaded') {
    // console.log('offerData:loaded');
    site.offerspick.eventCount++;
  } else if (event.type === 'transData:loaded') {
    // console.log('transData:loaded');
    site.offerspick.eventCount++;
  }
  if (site.offerspick.eventCount === 2) {
    // console.log('all data loaded');
    site.offerspick.getProducts();
  }
});

$(document).on('foundation_finder_grid', function (e, grid) {
  // not always ready on load
  var $grid = $(grid);
  var $lastImage = $('.product-thumb__image', $grid).last();

  $($lastImage).load(function () {
    Drupal.behaviors.productGrid.equalHeights($grid.parent());
  });
});

(function ($) {
  Drupal.behaviors.offersPickV2 = {
    attach: function (context) {
      site.offerspick.init();
    }
  };
})(jQuery);
